module.exports = __webpack_public_path__ + "static/media/coursio-creen.8bb01cb7.png";